/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { SaveSBPB2CDriverBankMutationRequest, SaveSBPB2CDriverBankMutationResponse, SaveSBPB2CDriverBank400, SaveSBPB2CDriverBank401, SaveSBPB2CDriverBank403, SaveSBPB2CDriverBank500, SaveSBPB2CDriverBank503 } from "../entities/SaveSBPB2CDriverBank";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { saveSBPB2CDriverBank } from "../api/saveSBPB2CDriverBank";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const saveSBPB2CDriverBankMutationKey = () => [{ url: '/api/v1/payouts/sbp-b2c/bank' }] as const

export type SaveSBPB2CDriverBankMutationKey = ReturnType<typeof saveSBPB2CDriverBankMutationKey>

export function saveSBPB2CDriverBankMutationOptions<TContext = unknown>(config: Partial<RequestConfig<SaveSBPB2CDriverBankMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = saveSBPB2CDriverBankMutationKey()
        return mutationOptions<SaveSBPB2CDriverBankMutationResponse, ResponseErrorConfig<SaveSBPB2CDriverBank400 | SaveSBPB2CDriverBank401 | SaveSBPB2CDriverBank403 | SaveSBPB2CDriverBank500 | SaveSBPB2CDriverBank503>, {data: SaveSBPB2CDriverBankMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return saveSBPB2CDriverBank(data, config)
          },
        })

}

/**
 * @description Сохраняет выбранный водителем банк СБП, телефон получателя и email для месячных чеков СМЗ (необязательный).
 * Сохранённый банк становится текущим: на него уходят следующие выплаты
 * (`POST /api/v1/payouts/sbp-b2c`). Прежние выборы остаются в истории.
 * **Требования:**
 * - JWT access-токен водителя (`Authorization: Bearer`) и заголовки `user-id`, `city-id`
 * - `user-id` должен совпадать с пользователем из токена, иначе `403`
 * Телефон и email хранятся только в зашифрованном виде.
 * @summary Сохранение банка СБП водителя
 * {@link /api/v1/payouts/sbp-b2c/bank}
 */
export function useSaveSBPB2CDriverBank<TContext>(options: 
{
  mutation?: UseMutationOptions<SaveSBPB2CDriverBankMutationResponse, ResponseErrorConfig<SaveSBPB2CDriverBank400 | SaveSBPB2CDriverBank401 | SaveSBPB2CDriverBank403 | SaveSBPB2CDriverBank500 | SaveSBPB2CDriverBank503>, {data: SaveSBPB2CDriverBankMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<SaveSBPB2CDriverBankMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? saveSBPB2CDriverBankMutationKey()

          const baseOptions = saveSBPB2CDriverBankMutationOptions(config) as UseMutationOptions<SaveSBPB2CDriverBankMutationResponse, ResponseErrorConfig<SaveSBPB2CDriverBank400 | SaveSBPB2CDriverBank401 | SaveSBPB2CDriverBank403 | SaveSBPB2CDriverBank500 | SaveSBPB2CDriverBank503>, {data: SaveSBPB2CDriverBankMutationRequest}, TContext>
          

          return useMutation<SaveSBPB2CDriverBankMutationResponse, ResponseErrorConfig<SaveSBPB2CDriverBank400 | SaveSBPB2CDriverBank401 | SaveSBPB2CDriverBank403 | SaveSBPB2CDriverBank500 | SaveSBPB2CDriverBank503>, {data: SaveSBPB2CDriverBankMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<SaveSBPB2CDriverBankMutationResponse, ResponseErrorConfig<SaveSBPB2CDriverBank400 | SaveSBPB2CDriverBank401 | SaveSBPB2CDriverBank403 | SaveSBPB2CDriverBank500 | SaveSBPB2CDriverBank503>, {data: SaveSBPB2CDriverBankMutationRequest}, TContext>
      
}